import { ApplicationConfig, importProvidersFrom, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { ApiModule, Configuration as ApiConfiguration } from 'src/app/api';
import { CAPTCHA_CONFIG } from 'src/app/reusables/captcha';

import { environment } from '../environments/environment';

import { provideTranslateServiceInitializer } from './initializers';
import { routes } from './app.routes';


export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withHashLocation()),
        provideHttpClient(),
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
        { provide: CAPTCHA_CONFIG, useValue: { ...environment.captcha } },
        provideAppInitializer(provideTranslateServiceInitializer()),
        importProvidersFrom(
            ApiModule.forRoot(
                () => new ApiConfiguration({
                    basePath: environment.api.basePath
                })
            )
        ),
    ]
};
